import logo from './logo.svg';
import './Invitation.css';

import React, { useState, useReducer, useEffect, ChangeEventHandler, ChangeEvent, SyntheticEvent, KeyboardEvent, createContext } from "react";
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ButtonGroup from '@mui/material/ButtonGroup';
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Icon from '@mui/material/Icon';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useParams} from 'react-router-dom';

import SettingsIcon from '@mui/icons-material/Settings';
import CelebrationIcon from '@mui/icons-material/Celebration';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CancelIcon from '@mui/icons-material/Cancel';
import CakeIcon from '@mui/icons-material/Cake';
import RestaurantIcon from '@mui/icons-material/Restaurant';

// import invitationBanner from './invitation_banner.jpg';

import axios from 'axios';
import { Buffer } from 'buffer';

// const baseURL = "http://localhost/rest";
const baseURL = "https://event.janeks.de/rest";
// const baseURL = "https://game.janeks.de/rest";

const comeState = {
  Undefined: 0,
  Cancled: 1,
  Maybe: 2,
  Comes: 3,
};

const foodType = {
  1: "Vegan",
  2: "Vegetarisch",
  3: "Wahlweise",
  4: "Mit Fleisch",
};

const foodPortions = {
  2: "2-4",
  4: "4-6",
  6: "6-8",
  8: "8+",
};

const initialFood = [
  // { id: 0, food: "Brownie", type: "Vegetarisch", portions: "2-4" },
  // { id: 1, food: "Cheesecake", type: "Vegan", portions: "8+" },
];
const columns = [
  
  { 
    field: 'food', 
    headerName: 'Snack', 
    // width: 120 
  },
  {
    field: 'type',
    headerName: 'Art',
    // type: 'string',
    // width: 70,
  },
  {
    field: 'portions',
    headerName: 'Portionen',
    // type: 'string',
    // width: 70,
  },
];

const ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove',
  CLEAR: 'clear',
  UPDT_VALS: 'updt_vals',
}


function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.ADD:
      return [...state, newFood(action.data)]
      break;
    case ACTIONS.REMOVE:
      return state.filter((stat) => stat.node !== action.pl.node);
      break;
    case ACTIONS.CLEAR:
        return [];
        break;
    case ACTIONS.UPDT_VALS:
      return state.map((stat) => {
        if (stat.colNode === action.pl.node) {
          let valKeys = Object.keys(action.vals);
          for (let i in valKeys) {
            if (stat.colType == valKeys[i]) {
              return {...stat, colValue: action.vals[valKeys[i]] };
            }    
          }
          return stat;
        } else {
          return stat;
        }
      });
      break;
    default:
      return state
  }
}

function newFood(food) {
  return {
    id: food['id'], food: food['description'], type: foodType[food['type']], portions: foodPortions[food['amount']]
  }
}

let linkStr = "";
let refresherEnabled = false;

function Invitation() {
    const { userId, mode } = useParams();

    const [food, updateFood] = useReducer(reducer, initialFood);
    const [height, setHeight] = React.useState(0)
    const ref = React.useRef([])

    const [validUser, setValidUser] = useState(false);
    const [locationBriefPars, setLocationBriefPars] = useState([]);
    const [invitationTextPars, setInvitationTextPars] = useState([]);
    const [plusOneEn, setPlusOneEn] = useState(true);
    const [plusOne, setPlusOne] = useState('');
    const [drinkWish, setDrinkWish] = useState('');
    const [pizzaTopping, setPizzaTopping] = useState('');

    const [bringDescription, setBringDescription] = useState('');
    const [bringType, setBringType] = useState(0);
    const [bringAmount, setBringAmount] = useState(0);

    React.useEffect(() => {
      let newHeight = ref.current.clientWidth;
      if (newHeight > 940) newHeight = 940;
      setHeight(newHeight * 0.5);
    }, [])

    // Onload check if user is valid
    React.useEffect(() => {
      checkGuestKey();
      loadInvitation();
      relodToBring();
      if (!refresherEnabled) {
        refresherEnabled = true;
        setInterval(() => {
          relodToBring();
        }, 10000);
      }
    }, [])

    const [guestComes, setGuestComes] = React.useState(comeState.Undefined);
    const [guestComesEdit, setGuestComesEdit] = React.useState(true);
    const [foodListBox, setFoodListBox] = React.useState(false);

    const handleGuestCancles = (e) => {
      setGuestComes(comeState.Cancled);
      setFoodListBox(false);
      updateParticipant({come_state: comeState.Cancled});
    }

    const handleGuestComes = (e) => {
        setGuestComes(comeState.Comes);
        setGuestComesEdit(false);
        updateParticipant({come_state: comeState.Comes});
    }

    const handleGuestMaybe = (e) => {
      setGuestComes(comeState.Maybe);
      updateParticipant({come_state: comeState.Maybe});
    }

    const handleGuestComesEdit = (e) => {
        setGuestComesEdit(true);
    }

    const handleFood = (e) => {
        setFoodListBox(true);
    }

    const handleBringDescription = (e) => {
      setBringDescription(e.target.value);
      if (e.target.value == "") {
        setBringType("");
        setBringAmount("");
        updateToBring({description: "", type: null, amount: null});
      } else {
        updateToBring({description: e.target.value})
      }
    }

    function checkGuestKey() {
      let key = userId;
      if (key && key.length == 16) {
        linkStr = key;
      } else {
        console.log("No guest key.")
      }
    }

    function updateInvitation(data) {
      setLocationBriefPars(data['locationBrief'].split('\n'));
      setInvitationTextPars(data['invitationText'].split('\n'));
      setGuestComes(data['come_state']);
      if (data['come_state'] == comeState.Comes) {
        setGuestComesEdit(false);
      }
      setPlusOneEn(data['plus_one_en']==1);
      setPlusOne(data['plus_one'] || '');
      setDrinkWish(data['q_1'] || '');
      setPizzaTopping(data['q_2'] || '');

      if (data['tb_description'] && data['tb_description'].length > 0) {
        setFoodListBox(true);

        setBringDescription(data['tb_description'] || '');
        setBringType(data['tb_type'] || '');
        setBringAmount(data['tb_amount'] || '');
      }
    }

    // Axios functions
    function relodToBring() {
      axios
      .get(
        baseURL+"/invitation/bring", {
          params: {
            link: linkStr
          },
        })
      .then((response) => {
        updateFood({type: ACTIONS.CLEAR});
        response.data['bring_list'].map(item => {  
          updateFood({type: ACTIONS.ADD, data: item});
      });}
      ).catch((error) => {
        console.log(error);
      });
    }

    function loadInvitation() {
      axios
      .get(
        baseURL+"/invitation", {
          params: {
            link: linkStr
          },
        })
      .then((response) =>
        updateInvitation(response.data)      
      ).catch((error) => {
        console.log(error);
      });
    }

    function updateParticipant(param) {
      axios
      .post(
        baseURL+"/invitation/participant", {
          link: linkStr,
          ...param
        })
      .then((response) =>
      setValidUser(true)
      ).catch((error) => {
        console.log(error);
      });
    }

    function updateToBring(param) {
      axios
      .post(
        baseURL+"/invitation/bring", {
          link: linkStr,
          ...param
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
      .then((response) =>
        console.log(response.data)
      ).catch((error) => {
        console.log(error);
      });
    }
  
  return (
    <Box className="App">
      <Grid container direction="row" spacing={2} justifyContent="space-between" sx={{padding: 2}}>
        <Grid item>
          <Typography variant="h5" component="h1" color="primary">
            Feier zum 29. Geburtstag
          </Typography>
          </Grid>
      </Grid>
      <div className="invitationBanner" ref={ref} style={{ height: height, width: "100%", display: 'flex' }}>
        <Typography variant="body1" gutterBottom style={{fontSize: 9, alignSelf: 'flex-end', marginLeft: 'auto', padding: 10}}>
          *Tatsächliche Location kann abweichen :)
        </Typography>
      </div>
      <Grid container spacing={2}>
        <Grid item  xs={12} md={12}>
          <Card sx={{p: 2}}>{/* variant="outlined" */}
            
            <Box sx={{p: 2}}>
            
            {/* <invitationBanner/> */}
            {/* <img src="/images/invitation_banner.jpg" alt="invitationBanner" style={{width: '90%'}}/> */}
            <Collapse in={(guestComes == comeState.Maybe || guestComes == comeState.Comes)}>
              <Paper style={{width: 300, padding: 3, margin: 'auto'}}>
                <Typography variant="body1">
                    {locationBriefPars.map((par, index) => (
                    <React.Fragment>
                    {index > 0 && <br />}
                    {par}
                  </React.Fragment>
                  ))}
                  {/* Gerne mitbringen: Gute Laune und -Essen- */}
                </Typography>
              </Paper>
            </Collapse>
            <Typography variant="body1" gutterBottom>
              <br/>
              {invitationTextPars.map((par, index) => (
              <React.Fragment>
                {index > 0 && <br />}
                {par}
              </React.Fragment>
              ))}
              <br/>
            </Typography>
            </Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}
              sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              { guestComesEdit &&
              <Button variant="text" onClick={handleGuestCancles} startIcon={<CancelIcon />}
              disabled={guestComes == comeState.Cancled}>
                Kann nicht...
              </Button>}
              
              { (guestComes == comeState.Cancled || guestComes == comeState.Maybe) &&
              <Button variant="outlined" onClick={handleGuestMaybe} endIcon={<QuestionMarkIcon />}
                disabled={guestComes == comeState.Maybe}>
                Vielleicht
              </Button>}
                
              { guestComesEdit &&
              <Button variant="contained" onClick={handleGuestComes} endIcon={<CelebrationIcon />}>
                Ich bin dabei!
              </Button>}
              { !guestComesEdit &&
              <Box>
              <Button variant="contained" color="success" endIcon={<CelebrationIcon />} disableElevation>
                Du bist dabei!
              </Button>
              <IconButton aria-label="delete" onClick={handleGuestComesEdit}>
                <SettingsIcon />
              </IconButton>
              </Box>}
            </Stack>
            {plusOneEn &&
              <TextField sx={{marginTop: 1}} 
                id="standard-basic" 
                label="Begleitende*r Partner*in" 
                variant="standard" 
                onChange={(e) => {
                  setPlusOne(e.target.value);
                  updateParticipant({plus_one: e.target.value})
                }} 
                value={plusOne}/>}


            <Collapse in={(guestComes == comeState.Comes)}>
              {/* <Box>
                <br/>
                <Divider variant="middle" light sx={{p: 2}}>OPTIONAL</Divider>

                  <TextField id="standard-basic" 
                    label="Getränke-Wunsch für die Bar" 
                    variant="standard"  
                    sx={{width: 207, margin: 1}}
                    onChange={(e) => {
                      setDrinkWish(e.target.value);
                      updateParticipant({q_1: e.target.value})
                    }}
                    value={drinkWish}/>
                  <TextField id="standard-basic"
                    label="Lieblings-Pizza-Topping"
                    variant="standard"
                    sx={{width: 207, margin: 1}}
                    onChange={(e) => {
                      setPizzaTopping(e.target.value);
                      updateParticipant({q_2: e.target.value})
                    }}
                    value={pizzaTopping}/>
                
              </Box> */}
            </Collapse>
              {  (guestComes == comeState.Comes && !foodListBox) &&
              <Button variant="outlined" onClick={handleFood} endIcon={<RestaurantIcon />} sx={{m: 3}}>
                Ich habe Lust etwas mitzubringen!
              </Button>}
            <Collapse in={foodListBox}>
              <Box>
                {/* <Typography variant="h6" gutterBottom>
                  Leckereien<CakeIcon />
                </Typography> */}
                <Grid container spacing={2} sx={{p: 5}}>
                  <Grid item  xs={12} md={7}>
                    <FormGroup>
                    <TextField id="standard-basic" 
                      label="Ich bringe mit" 
                      variant="standard"
                      onChange={handleBringDescription}
                      value={bringDescription}/>
                    </FormGroup>
                  </Grid>
                  <Grid item  xs={12} md={5}>
                    <FormControl>
                      <FormLabel id="food-type-group-label">Art</FormLabel>
                      <RadioGroup
                        aria-labelledby="food-type-group-label"
                        // defaultValue="female"
                        name="radio-buttons-group"
                        onChange={(e) => {
                          setBringType(e.target.value);
                          updateToBring({type: e.target.value})
                        }}
                        value={bringType}
                      >
                        <FormControlLabel value="4" control={<Radio />} label="Mit Fleisch" />
                        <FormControlLabel value="2" control={<Radio />} label="Vegetarisch" />
                        <FormControlLabel value="1" control={<Radio />} label="Vegan" />
                        <FormControlLabel value="3" control={<Radio />} label="Wahlweise" />
                      </RadioGroup>
                    </FormControl>
		{/*<FormControl>
                      <FormLabel id="food-portions-group-label">Portionen</FormLabel>
                      <RadioGroup
                        aria-labelledby="food-portions-group-label"
                        name="radio-buttons-group" 
                        onChange={(e) => {
                          setBringAmount(e.target.value);
                          updateToBring({amount: e.target.value})
                        }}
                        value={bringAmount}
                      >
                        <FormControlLabel value="2" control={<Radio />} label="2-4" />
                        <FormControlLabel value="4" control={<Radio />} label="4-6" />
                        <FormControlLabel value="6" control={<Radio />} label="6-8" />
                        <FormControlLabel value="8" control={<Radio />} label="8+" />
                      </RadioGroup>
                    </FormControl>*/}
                  </Grid>
                </Grid>
                

                {/* <Box style={{ height: 800, width: '100%' }}>
                  <DataGrid
                    rows={food}
                    columns={columns}
                    pageSize={15}
                    rowsPerPageOptions={[15]}
                    // checkboxSelection
                    disableSelectionOnClick
                    // onRowClick={(e) => 
                    //   openGuestEditor(e.row.id)
                    // }
                  />
                </Box> */}
                <TableContainer component={Paper}>
                  <Table md={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Bisher auf dem Buffet</TableCell>
                        <TableCell align="right">Art</TableCell>
		{/*                        <TableCell align="right">Portionen</TableCell>*/}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {food.map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {row.food}
                          </TableCell>
                          <TableCell align="right">{row.type}</TableCell>
			      {/*                          <TableCell align="right">{row.portions}</TableCell>*/}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Collapse>
          </Card>
        </Grid>
      </ Grid>
    </Box>
  );
}

export default Invitation;
